import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import axios from "axios"
import { TM_NOTIFICATIONS } from '../../../../../../../utility/SourceAPI'
import { formattedDate } from '../../../../../../../utility/formats/formattedDate'

const buildTMNotificationsUrl = (filters = {}) => {
    const data = Array.isArray(filters) ? { tax_mailbox: filters } : filters || {}
    const params = {}

    if (data.tax_mailbox !== undefined) {
        params.tax_mailbox = data.tax_mailbox
    }

    const queryString = Object.keys(params)
        .map(key => {
            const values = (Array.isArray(params[key]) ? params[key] : [params[key]])
                .filter(value => value !== undefined && value !== null && value !== '')
            return values.map(value => `${key}=${encodeURIComponent(value)}`).join('&')
        })
        .join('&')

    const dateQuery = data.rangeDates?.start !== undefined && data.rangeDates?.end !== undefined ? `start=${formattedDate(data?.rangeDates?.start)}&end=${formattedDate(data?.rangeDates?.end)}` : ''
    const typeFilterQuery = data.type_filter ? `type_filter=${encodeURIComponent(data.type_filter)}` : ''
    const query = [queryString, dateQuery, typeFilterQuery].filter(Boolean).join('&')

    return `${TM_NOTIFICATIONS}${query ? `?${query}` : ''}`
}

export const getTMNotifications = createAsyncThunk('appTMNotifications/getTMNotifications', async (filters) => {
    const response = await axios.get(buildTMNotificationsUrl(filters))
    return {
        data: response.data
    }
})

export const getTMNotificationsByMailBox = createAsyncThunk('appTMNotifications/getTMNotificationsByMailBox', async (mailBoxId) => {
    const response = await axios.get(buildTMNotificationsUrl({ tax_mailbox: mailBoxId }))
    return {
        data: response.data
    }
})

export const getTMNotificationsToRelease = createAsyncThunk('appTMNotifications/getTMNotificationsToRelease', async () => {
    const response = await axios.get(`${TM_NOTIFICATIONS}?is_deleteable=true`)
    return {
        data: response.data
    }
})

export const createTMNotification = createAsyncThunk('appTMNotifications/createTMNotification', async (payload) => {
    const response = await axios.post(TM_NOTIFICATIONS, payload)
    return {
        data: response.data
    }
})

export const updateTMNotification = createAsyncThunk('appTMNotifications/updateTMNotification', async (data, { dispatch }) => {
    const response = await axios.put(TM_NOTIFICATIONS.concat(`${data.id}`), data)
    await dispatch(getTMNotifications())
    return {
        data: response.data
    }
})

export const deleteTMNotification = createAsyncThunk('appTMNotifications/deleteTMNotification', async (id, { dispatch }) => {
    const response = await axios.delete(TM_NOTIFICATIONS.concat(`${id}`))
    await dispatch(getTMNotifications())
    await dispatch(getTMNotificationsToRelease())
    return {
        data: response.data
    }
})

export const authorizeTMNotification = createAsyncThunk('appTMNotifications/authorizeTMNotification', async (data, { dispatch }) => {
    const response = await axios.put(`${TM_NOTIFICATIONS}authorized_deleted/${data.id}?authorized_deleted=${data.is_authorized_deleted}`)
    await dispatch(getTMNotifications())
    await dispatch(getTMNotificationsToRelease())
    return {
        data: response.data
    }
})

export const releaseTMNotification = createAsyncThunk('appTMNotifications/releaseTMNotification', async (id, { dispatch }) => {
    const response = await axios.put(`${TM_NOTIFICATIONS}is_deleteable/${id}?is_deleteable=true`)
    await dispatch(getTMNotifications())
    return {
        data: response.data
    }
})

export const tmNotificationsSlice = createSlice({
    name: 'appTMNotifications',
    initialState: {
        data: [],
        dataToRelease: []
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getTMNotifications.fulfilled, (state, action) => {
            state.data = action.payload.data
        })
        builder.addCase(getTMNotificationsToRelease.fulfilled, (state, action) => {
            state.dataToRelease = action.payload.data
        })
    }
})

export default tmNotificationsSlice.reducer
